export class ApiError extends Error {
  constructor(message: string, public status: number, public retryAfter = 0) { super(message); }
}
export async function api<T>(url: string, init?: RequestInit): Promise<T> {
  const timeout = new AbortController();
  const timer = setTimeout(() => timeout.abort(), 20_000);
  try {
    const response = await fetch(url, { ...init, signal: init?.signal ? AbortSignal.any([init.signal, timeout.signal]) : timeout.signal, headers: { ...(typeof window !== "undefined" && window.location.pathname.startsWith("/student") ? { "x-sat-local-preview": "student" } : {}), ...(init?.body ? { "content-type": "application/json" } : {}), ...init?.headers } });
    if (!response.ok) throw new ApiError((await response.json().catch(() => null) as { error?: string } | null)?.error ?? `Request failed (${response.status})`, response.status, Math.max(0, Number(response.headers.get("retry-after")) || 0));
    const data = await response.json() as T;
    if (init?.method && !["GET", "HEAD"].includes(init.method.toUpperCase()) && typeof window !== "undefined") window.dispatchEvent(new Event("sat:portal-invalidated"));
    return data;
  } catch (error) {
    if (timeout.signal.aborted) throw new Error("The request timed out. Check your connection and retry.");
    if (error instanceof TypeError) throw new Error("Could not connect. Check your connection and retry.");
    throw error;
  } finally { clearTimeout(timer); }
}
